jQuery(document).ready(function($) {

  /*
  jQuery throttle / debounce - v1.1 - 3/7/2010 -- Rewritten to accommodate webpack compilation
  http://benalman.com/projects/jquery-throttle-debounce-plugin/
  */
  function st_throttle(e,f,j,i){var c=undefined;var h,d=0;if(typeof f!=="boolean"){i=j;j=f;f=c}function g(){var o=this,m=+new Date()-d,n=arguments;function l(){d=+new Date();j.apply(o,n)}function k(){h=c}if(i&&!h){l()}h&&clearTimeout(h);if(i===c&&m>e){l()}else{if(f!==true){h=setTimeout(i?k:l,i===c?e-m:e)}}}if($.guid){g.guid=j.guid=j.guid||$.guid++}return g}

  /*
  $(window).on('scroll', st_throttle(500, function() {
    console.log('do something');
  }));
  */

  /* COLORED ICON CTA GRID -------------------------------------- */
  $('.colored-icon-cta-grid').each(function() {

    var $grid = $(this);

    function set_cta_height() {

      var min_height = 0;

      $('.colored-icon-cta > .wrap', $grid).css({
        'min-height': ''
      });

      if ($(window).width() > 600) {

        $('.colored-icon-cta', $grid).each(function() {

          var $cta = $(this);
          var cta_height = $('> .wrap', $cta).innerHeight();

          if (cta_height > min_height) {
            min_height = cta_height;
          }

        });

        $('.colored-icon-cta > .wrap', $grid).css({
          'min-height': min_height+'px'
        });

      }

    }

    set_cta_height();

    $(window).on('resize', st_throttle(500, function() {
      set_cta_height();
    }));

  });


  /* MULTI-SLIDER ----------------------------------------------- */
  $('.multi-slider-block').each(function() {

    // The following set_modal_window_height function allows you to set heights of different sections of the modal window upon modal window opening
    function set_modal_window_height() {
      
      var container_height = $('.modaal-wrapper .modaal-container').height();
      var content_height = container_height;
  
      console.log('Container Height: '+container_height);
      console.log('Content Height: '+content_height);
  
      $('.modaal-wrapper .modaal-container .slider-modal-info').css({
        'height': container_height+'px'
      });
    }
  
    function initialize_modal_windows($slider) {
      $('a.wrap.modal', $slider).modaal({
        custom_class: 'multi-slider-modal-window',
        background: '#fff',
        overlay_opacity: 0.5,
        width: 650
        // after_open: set_modal_window_height
      });
    }

    var $container = $(this);
    var $slider_container = $('.multi-slider', $container);
    var $slider = $('.slider > .wrap', $slider_container);
    var slide_count = $('.item', $slider).length;
    var $slider_nav = $('.slider-nav', $container);
    var $nav_prev = $('.slider--prev', $slider_nav);
    var $nav_next = $('.slider--next', $slider_nav);
    var autoplay = ( $container.hasClass('autoplay-slider') ? true : false );
    var autoplay_speed = ( autoplay ? $container.data('autoplay-speed') : 4000 );
    var transition_speed = ( autoplay ? $container.data('transition-speed') : 1000 );
    
    $nav_prev.each(function() {
      $(this).on('click', function() {
        $slider.slick('slickPrev');
      });
    });
    
    $nav_next.each(function() {
      $(this).on('click', function() {
        $slider.slick('slickNext');
      });
    });
    
    $slider.on('init reInit breakpoint', function(slick) {
      
      // Make sure slider is visible
      $slider_container.addClass('show');

      // Determine if custom navigation should show/hide
      var active_slides = $('.slick-active', $slider).length;
      if (active_slides < slide_count) {
        $slider_nav.addClass('show');
      } else {
        $slider_nav.removeClass('show');
      }

      // Re-initialize modal windows if this is a modal slider
      if ($container.hasClass('modal')) {
        initialize_modal_windows($slider);
      }
     
    });

    // Set slider variables
    var slider_args = {
      dots: false,
      arrows: false,
      infinite: true,
      slidesToShow: 5,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1921,
          settings: {
            slidesToShow: 4
          }
        },
        {
          breakpoint: 1441,
          settings: {
            slidesToShow: 3
          }
        },
        {
          breakpoint: 961,
          settings: {
            slidesToShow: 2
          }
        },
        {
          breakpoint: 481,
          settings: {
            slidesToShow: 1
          }
        }
      ]
    };

    // Set autoplay variables if necessary
    if (autoplay) {
      slider_args['autoplay'] = true;
      slider_args['autoplaySpeed'] = autoplay_speed;
      slider_args['speed'] = transition_speed;
    }

    $slider.slick(slider_args);

  });

  
  /* POSTS GRID ------------------------------------------------- */
  $('.posts-block').each(function() {

    // Declare variables
    $container = $(this);
    $filter = $('.post-list-filtering', $container);
    $category_filter = $('select[name="filter-category"]', $filter);
    $text_search = $('input[name="filter-text"]', $filter);

    $text_search.on('focus', function() {
      if ($(this).val() == 'Search by keyword...') {
        $(this).val('');
      }
    });

    $text_search.on('blur', function() {
      if ($(this).val() == '') {
        $(this).val('Search by keyword...');
      }
    });

    $filter.on('submit', function() {
      if ($text_search.val() == 'Search by keyword...') {
        $text_search.val('');
      }
    });

    $category_filter.on('change', function() {
      $filter.submit();
    });

  });


  /* RECENT POSTS BLOCK ----------------------------------------- */
  // Essentially the same as the posts list but it's a slider
  $('.post-list.slider').each(function() {

    var $container = $(this);
    var $slider = $('> .wrap', $container);

    function set_slide_height() {

      var min_height = 0;

      $('article.item', $slider).css({
        'min-height': ''
      });

      $('article.item', $slider).each(function() {

        var this_height = $(this).innerHeight();
        
        if (this_height > min_height) {
          min_height = this_height;
        }
        
      });

      $('article.item', $slider).css({
       'min-height': min_height+'px'
      });

    }
    
    $slider.on('init reInit breakpoint', function(slick) {

      set_slide_height();

    });

    $(window).on('resize', st_throttle(500, function() {
      set_slide_height();
    }));

    $slider.slick({
      arrows: false,
      dots: true,
      slidesToShow: 4,
      responsive: [
        {
          breakpoint: 1921,
          settings: {
            slidesToShow: 3
          }
        },
        {
          breakpoint: 1201,
          settings: {
            slidesToShow: 2
          }
        },
        {
          breakpoint: 601,
          settings: {
            slidesToShow: 1
          }
        }
      ]
    });

  });


  /* TESTIMONIALS SLIDER ---------------------------------------- */
  $('.testimonials-slider').each(function() {

    // Declare variables
    var $slider = $(this);
    var slide_count = $('.item', $slider).length;

    function set_slide_height() {

      // Only set slide heights if there's more than one slide
      if (slide_count > 1) {

        // Set minimum height to zero
        var min_height = 0;

        // Reset all slides
        $('.item .content', $slider).css({
          'min-height': ''
        });

        // Test each slide's content height
        $('.item .content', $slider).each(function() {

          var this_height = $(this).innerHeight();
          
          // If this slide's height is taller than the minimum height variable, set the min height
          if (this_height > min_height) {
            min_height = this_height;
          }
          
        });

        // Set minimum height of all slides
        $('.item .content', $slider).css({
          'min-height': min_height+'px'
        });

      }

    }
    
    // Handle init/reinit/breakpoint actions
    $slider.on('init reInit breakpoint', function(slick) {

      set_slide_height();

    });

    // Resize slide heights on window resize
    $(window).on('resize', st_throttle(500, function() {
      set_slide_height();
    }));
    
    // Create base slider arguments
    var slider_args = {
      'arrows': false,
      'dots': true,
      'fade': true,
      'slidesToShow': 1
    }

    // If more than one slide exists, set the autoplay values
    if (slide_count > 1) {
      slider_args['autoplay'] = true;
      slider_args['autoplaySpeed'] = 5000;
    }

    // Instantiate the slider
    $slider.slick(slider_args);
    
  });

});